import { useInstance } from 'intact-vue-next';
export function useKeyboard(getStep, getNewValue, fixValue, isFirst, dragging, triggerChangeEvent) {
  var instance = useInstance();
  var oldValue;
  function onKeydown(_ref) {
    var keyCode = _ref.keyCode;
    if (instance.get('disabled')) return;
    var _instance$get = instance.get(),
      value = _instance$get.value,
      range = _instance$get.range;
    // remain the old value to detect whether it changed to trigger change event
    oldValue = value;
    if (range) {
      var _value = value,
        min = _value[0],
        max = _value[1];
      value = isFirst() ? min : max;
    }
    if (keyCode === 37) {
      // left
      var _getStep = getStep(value, 'decrease'),
        step = _getStep[0];
      updateValue(value - step);
    } else if (keyCode === 39) {
      var _getStep2 = getStep(value, 'increase'),
        _step = _getStep2[0];
      updateValue(value + _step);
    }
  }
  function updateValue(value) {
    // disable transition
    dragging.set(true);
    fixValue(getNewValue(value), true);
  }
  function onKeyup(_ref2) {
    var keyCode = _ref2.keyCode;
    if (keyCode === 37 || keyCode === 39) {
      dragging.set(false);
      triggerChangeEvent(oldValue);
    }
  }
  return {
    onKeydown: onKeydown,
    onKeyup: onKeyup
  };
}